/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { EventArgs, markType } from "./type";
/**
 * @hidden
 */
var KeyEventArgs = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(KeyEventArgs, _super);
    function KeyEventArgs(a) {
        var _rest = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            _rest[_i - 1] = arguments[_i];
        }
        var _this = this;
        a = (a == void 0) ? 0 : a;
        switch (a) {
            case 0:
                {
                    var c = _rest[0];
                    var d = [c.which, c.altKey, c.shiftKey, c.ctrlKey];
                    {
                        var f = d[0];
                        var g = d[1];
                        var h = d[2];
                        var i = d[3];
                        _this = _super.call(this) || this;
                        _this.f = 0;
                        _this.j = 0;
                        _this.e = null;
                        _this.f = f;
                        _this.j = KeyEventArgs.i(g, h, i);
                    }
                    _this.e = c;
                }
                break;
            case 1:
                {
                    var c = _rest[0];
                    var d = _rest[1];
                    var e = _rest[2];
                    var f = _rest[3];
                    _this = _super.call(this) || this;
                    _this.f = 0;
                    _this.j = 0;
                    _this.e = null;
                    _this.f = c;
                    _this.j = KeyEventArgs.i(d, e, f);
                }
                break;
        }
        return _this;
    }
    Object.defineProperty(KeyEventArgs.prototype, "alt", {
        get: function () {
            return 1 == (this.j & 1);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(KeyEventArgs.prototype, "ctrl", {
        get: function () {
            return 2 == (this.j & 2);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(KeyEventArgs.prototype, "keyCode", {
        get: function () {
            return this.f;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(KeyEventArgs.prototype, "modifiers", {
        get: function () {
            return this.j;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(KeyEventArgs.prototype, "shift", {
        get: function () {
            return 4 == (this.j & 4);
        },
        enumerable: true,
        configurable: true
    });
    KeyEventArgs.prototype.preventDefault = function () {
        this.e.preventDefault();
    };
    KeyEventArgs.i = function (a, b, c) {
        var d = 0;
        if (a) {
            d |= 1;
        }
        if (b) {
            d |= 4;
        }
        if (c) {
            d |= 2;
        }
        return d;
    };
    KeyEventArgs.$t = markType(KeyEventArgs, 'KeyEventArgs', EventArgs.$);
    return KeyEventArgs;
}(EventArgs));
export { KeyEventArgs };
//# sourceMappingURL=KeyEventArgs.js.map
